<template>
  <div class="home">
    <router-link to="/login">Login</router-link>
    <button class="logout" @click="$store.dispatch('auth/logout');">logout</button>
    <div class="fieldset ">
      <h2>Icons</h2>
      <div class="flex">
        <dashboard-icon></dashboard-icon>
        <del-icon></del-icon>
        <group-icon></group-icon>
        <more-icon></more-icon>
        <things-icon></things-icon>


      </div>
      <div class="flex">
        <dashboard-sidebar></dashboard-sidebar>
        <dots></dots>
        <home-icon></home-icon>
        <list-icon></list-icon>
        <logs-icon></logs-icon>
        <toggle-icon></toggle-icon>
        <logout></logout>
      </div>
    </div>
    <div class="fieldset">
      <h2>Input with icons</h2>

      <div class="wrap">
        <div>
          <p>Standart</p>
          <label class="input-cont">
            <div class="icon">
              <icon></icon>
            </div>
            <input>
          </label>
          <p>Error</p>
          <label class="input-cont error">
            <div class="icon">
              <icon></icon>
            </div>
            <input>
            <error></error>
          </label>
        </div>
        <div>
          <p>Standart only words</p>
          <label class="input-cont">
            <div class="icon">
              <icon></icon>
            </div>
            <input @keypress="delNumbers">
          </label>
          <p>Error</p>
          <label class="input-cont error">
            <div class="icon">
              <icon></icon>
            </div>
            <input @keypress="delNumbers">
            <error></error>
          </label>
        </div>
        <div>
          <p>Standart only numbers</p>
          <label class="input-cont">
            <div class="icon">
              <icon></icon>
            </div>
            <input @keypress="delString">
          </label>
          <p>Error</p>
          <label class="input-cont error">
            <div class="icon">
              <icon></icon>
            </div>
            <input @keypress="delString">
            <error></error>
          </label>
        </div>
        <div>
          <p>Standart with masks (tel)</p>
          <label class="input-cont">
            <div class="icon">
              <icon></icon>
            </div>
            <input v-model="tel"
                   v-mask="'+7 (###)-###-##-##'">
          </label>
          <p>Error</p>
          <label class="input-cont error">
            <div class="icon">
              <icon></icon>
            </div>
            <input v-model="tel"
                   v-mask="'+7 (###)-###-##-##'">
            <error></error>
          </label>
        </div>
      </div>
    </div>
    <div class="fieldset">
      <h2>Input with button</h2>
      <p>Standart</p>
      <label class="input-cont">
        <div class="icon">
          <icon></icon>
        </div>
        <input>
        <button class="show-pass"><icon></icon></button>
      </label>
      <p>Error</p>
      <label class="input-cont error">
        <div class="icon">
          <icon></icon>
        </div>
        <input>
        <button class="show-pass"><icon></icon></button>
        <error></error>
      </label>
      <p>Disabled and readonly</p>
      <label class="disabled-input">
        <p class="label">Имя</p>
        <input readonly disabled value="Марат">
      </label>
      <p>Underline</p>
      <label class="input-cont_underline">
        <label class="label">Новый пароль</label>
        <input type="password">
      </label>
    </div>
    <div class="fieldset">
      <h2>Input with label</h2>
      <div class="wrap">
        <div>
          <p>standart</p>
          <label class="input-cont input-cont_small">
            <p class="label">Label</p>
            <input>
          </label>
        </div>
        <div>
          <p>Error</p>
          <label class="input-cont input-cont_small error">
            <p class="label">Label</p>
            <input>
            <error></error>
          </label>
        </div>
      </div>
    </div>
    <div class="fieldset">
      <h2>Checkbox big</h2>
      <label class="check-cont_big check-cont">
        <input v-model='check' type="checkbox">
        <p class="check-label">Checkbox big</p>
      </label>
    </div>
    <div class="fieldset">
      <h2>Checkbox small</h2>
      <label class="check-cont_small check-cont">
        <input v-model="check" type="checkbox">
        <p class="check-label">Checkbox small</p>
      </label>
    </div>
    <div class="fieldset">
      <h2>Checkbox opacity</h2>
      <label class="check-cont_small check-cont check-cont_opacity">
        <input v-model="check" type="checkbox">
        <p class="check-label">Checkbox small</p>
      </label>
    </div>
    <div class="fieldset">
      <h2>Select</h2>
      <div class="wrap">
        <div class="select-cont">
          <p class="label">Single</p>
          <v-select :clearable="false"
                    :searchable="false"
                    :filterable="false"
                    :close-on-select="true"
                    :select-on-tab="true"
                    v-model="select"
                    :options="options"></v-select>
        </div>
        <div class="select-cont select-cont_multiple">
          <p class="label">Multiple</p>
          <v-select multiple
                    :searchable="true"
                    :clearable="false"
                    :options="options"></v-select>
        </div>
        <div class="select-cont error">
          <p class="label">Error</p>
          <v-select :clearable="false"
                    :searchable="false"
                    :filterable="false"
                    :close-on-select="true"
                    :select-on-tab="true"
                    v-model="select"
                    :options="options"></v-select>
          <error></error>
        </div>
      </div>
    </div>
    <div class="fieldset">
      <h2>Textarea</h2>
      <p>Standart</p>
      <label class="textarea-wrap">
        <p class="label">
          Label
        </p>
        <textarea></textarea>
      </label>
      <p>Error</p>
      <label class="textarea-wrap error">
        <p class="label">Label</p>
        <textarea></textarea>
        <error></error>
      </label>
    </div>
    <div class="fieldset btn-wrap">
      <h2>Buttons</h2>
      <div class="wrap">
        <button type="button" class="btn">Button</button>
        <button type="button" class="btn" disabled>Disabled</button>
        <button type="button" class="btn loading" disabled>Loading</button>
        <button type="button" class="btn btn-green">Button green</button>
        <button type="button" class="btn btn-blue">Light Blue</button>
        <button type="button" class="btn btn-transparent_blue">Transparent blue</button>
        <button type="button" class="btn btn-transparent_red">Transparent red</button>
        <button type="button" class="btn btn-transparent_dark">Transparent dark</button>

        <button type="button" disabled class="btn btn-transparent_dark">Transparent disabled</button>

        <btn-add></btn-add>
        <btn-cancel></btn-cancel>
        <add-thing></add-thing>
        <import-thing></import-thing>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import icon from '../components/Svg/loginPass'
import error from '../components/Forms/errors'
import {validate} from "../mixins/utils/validate";
import btnAdd from '../components/Forms/Btns/btnAdd'
import btnCancel from '../components/Forms/Btns/btnCancel'
import addThing from '../components/Forms/Btns/things/addThing'
import importThing from '../components/Forms/Btns/things/importThing'
import {hideSidebar} from "../mixins/utils/hideSidebar";

import dashboardIcon from '../components/Svg/cart_control/dashboardsIcon'
import delIcon from '../components/Svg/cart_control/delIcon'
import groupIcon from '../components/Svg/cart_control/groupIcon'
import moreIcon from '../components/Svg/cart_control/moreIcon'
import thingsIcon from '../components/Svg/cart_control/thingsIcon'

import dashboardSidebar from '../components/Svg/sidebar/dashboardicon'
import dots from '../components/Svg/sidebar/dots'
import homeIcon from '../components/Svg/sidebar/homeIcon'
import listIcon from '../components/Svg/sidebar/listIcon'
import logsIcon from '../components/Svg/sidebar/logsIcon'
import toggleIcon from '../components/Svg/sidebar/toggleIcon'
import logout from '../components/Svg/sidebar/logout'


export default {
  name: 'home',
  components: {
    icon,
    error,
    btnAdd,
    btnCancel,
    addThing,
    importThing,
    dashboardIcon,
    delIcon,
    groupIcon,
    moreIcon,
    thingsIcon,
    dashboardSidebar,
    dots,
    homeIcon,
    listIcon,
    logsIcon,
    toggleIcon,
    logout
  },
  mixins: [validate, hideSidebar],
  data() {
    return {
      tel: '',
      check: false,
      select: '',
      options: ['1',2,3,4,5, 1000, 123123,214125125,152512, 'длинный текст очень очень длинный']
    }
  }
}
</script>

<style lang="scss" scoped>
  .home {
    background: white no-repeat;
    background-size: cover;
    height: 100%;
    color: black;
    padding: 50px 0;
  }

  .flex {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .check-cont_big {
    background: white;
    padding: 10px;
  }

  .wrap {
    display: flex;
    flex-wrap: wrap;
    padding: 0 100px;

    div {
      margin: 0 10px 10px;
    }

    .icon {
      margin: 0;
    }
  }

  .v-select  {
    margin: 0!important;

    .vs__dropdown-menu {
      margin: 0!important;
    }
  }

  .fieldset {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h2 {
    margin-bottom: 30px;
  }

  p {
    margin-bottom: 10px;
  }

  label, .select-cont {
    width: 200px;
    margin-bottom: 10px;
  }

  a {
    margin-bottom: 40px;
    font-size: 40px;
    color: red;
    display: block;
  }

  .btn-wrap button {
    min-width: 200px;
    max-width: 200px;
    margin: 0 10px 10px;
  }

  .logout {
    font-size: 40px;
    color: red;
    display: block;
    margin: 0 auto;
  }
</style>
